import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          activityId: {
            $null: false
          },
          networkId: network?.id,
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
